<template>
    <div class="testimonialWrapper pt-3">
        <span class="cl2"><b>TESTIMONIALS</b></span>
        <carousel :per-page="1"
        :loop="true"
        :mouse-drag="true"
        :autoplay="true"
        :autoplayTimeout="3000"
        paginationActiveColor="#000"
        paginationColor="#979a9f"
        :paginationSize="7"
        :paginationPadding="isDesktop ? 5 : 3"
        class="exc-cat-carousel"
        :class="isDesktop ? 'pb-4' : 'pb-3'">
            <slide v-for="(value, index) in this.testimonials" :key="index" class="exc-cat-slider">
                <svg xmlns="http://www.w3.org/2000/svg" class="cls-22" :width="isDesktop ? 28 : 21" height="88" viewBox="0 0 28 88">
                    <text id="_" data-name="&quot;" class="cls-1" transform="translate(14 63)"><tspan x="-13.237" y="0">"</tspan></text>
                </svg>
                <div class="ratingsWrap">
                    <span v-for="index in 5" :key="index">
                        <svg v-if="index <= value.rating" xmlns="http://www.w3.org/2000/svg" class="pr-2" :width="isDesktop ? 27.624 : 21.624" height="26.267" viewBox="0 0 27.624 26.267">
                        <path id="Path_286" data-name="Path 286" class="clr-1" d="M13.808,0l4.27,8.648,9.545,1.388-6.908,6.731,1.633,9.5-8.541-4.485L5.275,26.267l1.633-9.5L0,10.036,9.545,8.648Z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" class="pr-2" :width="isDesktop ? 27.624 : 21.624" height="26.267" viewBox="0 0 27.624 26.267">
                        <path id="Path_286" data-name="Path 286" class="clr-2" d="M13.808,0l4.27,8.648,9.545,1.388-6.908,6.731,1.633,9.5-8.541-4.485L5.275,26.267l1.633-9.5L0,10.036,9.545,8.648Z"/>
                        </svg>
                    </span>
                </div>
                <div class="funFactsSeq">
                    <span class="funfactComment" v-html="value.comment"></span>
                    <span style="font-weight:600;color: #494c63;" :style="isDesktop ? 'font-size: 26px;' : 'font-size: 0.9rem;'" v-html="value.commentBy"></span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" class="cls-23" :width="isDesktop ? 28 : 21" height="88" viewBox="0 0 28 88">
                    <text id="_" data-name="&quot;" class="cls-1" transform="translate(14 63)"><tspan x="-13.237" y="0">"</tspan></text>
                </svg>
            </slide>
        </carousel>
    </div> 
</template>
<script>
export default {
  props: ['testimonials', 'isDesktop']
}
</script>
<style scoped>
.ratingsWrap {
    position: absolute;
    top: 5%;
    width: 50%;
}
.clr-1 {
    fill: #148c8d;
}
.clr-2 {
    fill: #979a9f;
}
.cl2 {
    color: #282d3f;
    font-size: 32px;
}
.cls-1 {
    fill: #494c63;
    font-size: 62px;
    font-family: SourceSansPro-Regular, Source Sans Pro;
}
.cls-22 {
    position: relative;
    top: -40%;
}
.cls-23 {
    position: relative;
    bottom: -30%;
}
.funFactsSeq {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width:60%;
}
.funfactComment {
  font-size: 18px;
}
@media only screen and (max-width: 480px) {
    .testimonialWrapper {
        background: #f6f6f6;
    }
    .cl2 {
        font-size: 1rem;
        letter-spacing: 0px;
    }
    .funfactComment {
        font-size: 0.7rem;
    }
    .ratingsWrap {
        top: 11%;
    }
    .cl-22 {
        top: -29%;
    }
    .funFactsSeq {
        width:80%;
    }
}
</style>



// WEBPACK FOOTER //
// TestimonialsSlider.vue?0e9b66fe